import { render, staticRenderFns } from "./PaxInput.vue?vue&type=template&id=277e81e2&scoped=true&"
import script from "./PaxInput.vue?vue&type=script&lang=js&"
export * from "./PaxInput.vue?vue&type=script&lang=js&"
import style0 from "./PaxInput.vue?vue&type=style&index=0&id=277e81e2&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e81e2",
  null
  
)

export default component.exports